<div class="d-flex justify-content-between">
  <div>
    <table *ngIf="circleReport" class="table circle-report">
      <thead>
        <th>Student</th>
        <th>
          <div (click)="previousWeek()" class="week-arrows">
            <i class="fas fa-chevron-circle-left pointer"></i>
          </div>
        </th>
        <th *ngFor="let weekDay of weekDays">
          <div class="month-name">{{getShortMonth(weekDay)}}</div>
          <div class="day-number">{{weekDay.getUTCDate()}}</div>
        </th>
        <th>
          <div class="week-arrows" [ngClass]="cutoffIndex === 7 ? '' : 'hidden'" (click)="nextWeek()">
            <i class="fas fa-chevron-circle-right pointer"></i>
          </div>
        </th>
      </thead>
      <tbody>
        <tr *ngFor="let row of circleReport">
          <td colspan="2">
            <a href="/classes/{{organizationID}}/class/{{classID}}/students/{{row.StudentID}}">{{row.Name}}</a>
          </td>
          <td *ngFor="let day of row.Days">
            <div [ngClass]="getVisibility(day)">
              <div *ngIf="!showMinutes" [ngClass]="getActivityClass(day)" [ngbTooltip]="secondsToMinutes(day.Seconds)">
                <div></div>
              </div>
              <div *ngIf="showMinutes">
                {{secondsToMinutes(day.Seconds)}}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="overlap-fix">
    <div class="mb-3">
      <div class="d-flex justify-content-between">
        <label for="showMinutes" class="mr-1 no-print label-fix">Show minutes</label>
        <label class="switch">
          <input [(ngModel)]="showMinutes" type="checkbox" id="showMinutes">
          <span class="slider round"></span>
        </label>
      </div>
      <!-- <h3 class="font-weight-bold"> Weekly Report Email Settings</h3> -->
      <div class="d-flex subscriptionSettings" *ngIf="subscriptionSettings && subscriptionSettings.length > 0" >
        <label class="mr-1 no-print label-fix large-label"> Weekly Report Email Settings</label>
        <div *ngFor="let subscriptionSetting of subscriptionSettings" class="d-flex justify-content-between">
          <span>{{ subscriptionSetting.TeacherName }}: </span>
          <label class="switch" *ngIf="!changingSubscription">
            <input [(ngModel)]="subscriptionSetting.IsOptedIn" type="checkbox"
              (change)="updateSubscription(subscriptionSetting)">
            <span class="slider round"></span>
          </label>
          <app-loading-spinner [text]="''" [noMargin]="true" *ngIf="changingSubscription"></app-loading-spinner>
        </div>
      </div>
    </div>
    <div class="d-flex mb-2">
      <div class="complete-session mr-2">
        <div></div>
      </div>
      Complete Session
    </div>
    <div class="d-flex mb-2">
      <div class="partial-session mr-2">
        <div></div>
      </div>
      Partial Session
    </div>
    <div class="d-flex mb-2">
      <div class="no-session mr-2">
        <div></div>
      </div>
      No Session
    </div>
  </div>
</div>